export default __webpack_public_path__ + "static/media/explorandes3.6c93f05e.jpg";